import React from 'react';
import PropTypes from 'prop-types';

import ExpansionButton from '../common/ExpansionButton';

const msgPropType = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    message: PropTypes.string.isRequired,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
});

const propTypes = {
    className: PropTypes.string,
    validationObj: PropTypes.shape({
        implemented: PropTypes.bool.isRequired,
        canPublish: PropTypes.bool.isRequired,
        messages: PropTypes.arrayOf(msgPropType),
        warnings: PropTypes.arrayOf(msgPropType),
        errors: PropTypes.arrayOf(msgPropType)
    })
};

const defaultProps = {
    className: '',
    validationObj: {
        implemented: false,
        canPublish: true,
        messages: [],
        warnings: [],
        errors: []
    }
};

function ValidationReport(props) {
    if (!props.validationObj.implemented) {
        return null;
    }

    return (
        <div className={`saveValidation ${props.className}`}>
            <ValidationMessageGroup
            messageGroupLabel="Messages"
            messageGroupClassName="info-text"
            messages={props.validationObj.messages}
            />
            <ValidationMessageGroup
            className="margin-top-sm"
            messageGroupLabel="Warnings"
            messageGroupClassName="warning-text"
            messages={props.validationObj.warnings}
            />
            <ValidationMessageGroup
            className="margin-top-sm"
            messageGroupLabel="Errors"
            messageGroupClassName="error-text"
            messages={props.validationObj.errors}
            />
        </div>
    );
}

ValidationReport.propTypes = propTypes;
ValidationReport.defaultProps = defaultProps;

export default ValidationReport;

class ValidationMessageGroup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        }

        this.onToggleExpanded = this.onToggleExpanded.bind(this);
    }

    onToggleExpanded() {
        this.setState({ expanded: !this.state.expanded });
    }

    render() {
        return (
            <div className={`saveValidation__Group ${this.props.className}`}>
                <ExpansionButton
                className="no-button-style"
                expanded={this.state.expanded}
                onClick={this.onToggleExpanded}
                >
                    <label>
                        {this.props.messageGroupLabel} (<span className={this.props.messageGroupClassName}>{this.props.messages.length}</span>)
                    </label>
                </ExpansionButton>
                <ul style={!this.state.expanded ? { display: 'none'} : {}}>
                    {this.props.messages.length === 0 &&
                        <li className="font-style-italic">None</li>
                    }
                    {this.props.messages.map((msgObj) => {
                        return <li className={this.props.messageGroupClassName} key={msgObj.id}>{msgObj.message}</li>;
                    })}
                </ul>
            </div>
        );
    }
}

ValidationMessageGroup.propTypes = {
    className: PropTypes.string,
    messageGroupClassName: PropTypes.string,
    messageGroupLabel: PropTypes.string.isRequired,
    messages: PropTypes.arrayOf(msgPropType),
};

ValidationMessageGroup.defaultProps = {
    className: '',
    messageGroupClassName: '',
    messages: [],
};